import React from "react";
import { App as AntApp } from "antd";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PublicBookingPage from "../../src/features/scheduling-public/publicBookingpage";

const PublicBookingApp: React.FC = () => (
  <AntApp>
    <BrowserRouter>
      <Routes>
        <Route
          path="/reschedule/:publicKey/:bookingId"
          element={<PublicBookingPage />}
        />
        <Route
          path="/book/reschedule/:publicKey/:bookingId"
          element={<PublicBookingPage />}
        />
        <Route
          path="/book/:publicKey/:bookingId"
          element={<PublicBookingPage />}
        />
        <Route path="/book/:publicKey" element={<PublicBookingPage />} />
        <Route path="/book" element={<PublicBookingPage />} />
        <Route path="/:publicKey" element={<PublicBookingPage />} />
        <Route path="/" element={<PublicBookingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </AntApp>
);

export default PublicBookingApp;
